import { render, staticRenderFns } from "./BusinessRecruiter.vue?vue&type=template&id=35bc8e9b&scoped=true&"
import script from "./BusinessRecruiter.vue?vue&type=script&lang=ts&"
export * from "./BusinessRecruiter.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessRecruiter.vue?vue&type=style&index=0&id=35bc8e9b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bc8e9b",
  null
  
)

export default component.exports